import {styled, TableCell, tableCellClasses, TableContainer, TableSortLabel} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import * as React from "react";
import {useEffect, useState} from "react";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import {getComparator, sortedRowInformation} from "../Hisps/HispsAsList";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function PublishedLeaderBoardDialog(props) {
    const {
        setLeaderBoardOpen,
        leaderBoardOpen,
    } = props

    const [orderDirection, setOrderDirection] = useState('asc');
    const [valueToOrderBy, setValueToOrderBy] = useState('hispId');
    const [contributions, setContributions] = useState([]);

    useEffect(() => {
        fetchPublishedData();
    }, [])

    useEffect(() => {
        if (contributions) {
            setContributions(() => sortedRowInformation(contributions, getComparator(orderDirection, valueToOrderBy)));
        }

    }, [orderDirection, valueToOrderBy])

    const fetchPublishedData = async () => {
        const url = ApiUrl.Published.getPublication.getPath("last", true, true);
        try {
            const res = await fetch(url);
            const data = await handleHttpResponse(res);
            setContributions(data.contributions);

        } catch (err) {
            console.error("Failed to get published data");
        }
    }

    const calculateErrors = (c) => {
        return c.toleratedErrorCount + c.errorCount;
    }


    const handleClose = () => {
        setLeaderBoardOpen(false);
    };

    const createSortHandler = (property) => (event) => {
        handleRequestSort(event, property);
    }

    const handleRequestSort = (event, property) => {
        const isAscending = (valueToOrderBy === property && orderDirection === 'asc');
        setValueToOrderBy(property);
        setOrderDirection(isAscending ? 'desc' : 'asc');
    }

    return (
        <div>
            {contributions &&
                <Dialog
                    open={leaderBoardOpen}
                    onClose={handleClose}
                    aria-labelledby="publishedHispsInfo-dialog-title"
                    aria-describedby="publishedHispsInfo-dialog-description"
                    maxWidth='md'
                >
                    <DialogTitle id="publishedHispsInfo-dialog-title">
                        Leader Board
                    </DialogTitle>
                    <DialogContent>
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650, m: 0}} size="small">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>No.</StyledTableCell>
                                        <StyledTableCell>
                                            <TableSortLabel
                                                active={valueToOrderBy === 'hisp'}
                                                direction={orderDirection}
                                                onClick={createSortHandler('hisp')}
                                            >
                                                Hisp
                                            </TableSortLabel>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <TableSortLabel>
                                                Errors
                                            </TableSortLabel>
                                        </StyledTableCell>
                                        <StyledTableCell>Score</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {contributions.map( (c, idx) => (
                                        <StyledTableRow key={c.id}>
                                            <StyledTableCell component="th" scope="row">
                                                {idx + 1}
                                            </StyledTableCell>
                                            <StyledTableCell>{c.hisp}</StyledTableCell>
                                            <StyledTableCell>error</StyledTableCell>
                                            <StyledTableCell>scores</StyledTableCell>
                                        </StyledTableRow>

                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </DialogContent>
                    <DialogActions sx={{display: 'flex', justifyContent: 'center', padding: '0 8px 12px 8px'}}>
                        <Button onClick={handleClose} autoFocus variant='contained'>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </div>
    );
}
